import api from './api';

const notificationService = {
  getNotifications: async (limit = 50) => {
    const response = await api.get(`/notifications?limit=${limit}`);
    return response;
  },

  markAsRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`);
    return response;
  },

  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response;
  },

  clearAll: async () => {
    const response = await api.delete('/notifications/all');
    return response;
  }
};

export default notificationService;
